'use client';
import { useState } from 'react';

//* Components
import Hero from '../components/Hero';
import Content from '../components/Content';
import Related from '../components/Related';

//* Style
import PostIndividualTemplateStyle from './style';

const PostIndividualTemplate = ({ pageData }) => {
	//! State
	const [isLoading, setIsLoading] = useState(false);

	return (
		<PostIndividualTemplateStyle>
			<Hero
				isLoading={isLoading}
				setIsLoading={setIsLoading}
				title={pageData.title}
				image={pageData.image}
			/>

			<Content
				isLoading={isLoading}
				date={pageData.date}
				category={pageData.category}
				description={pageData.description}
			/>

			<Related
				currentPostId={pageData.id}
				postCategoryId={pageData.category.id}
			/>
		</PostIndividualTemplateStyle>
	);
};

export default PostIndividualTemplate;
